(function() { window.GUID_5bfbc54a_6a80_440c_ae1e_14252e5b3e7a = { getGuid: function() { return "5bfbc54a-6a80-440c-ae1e-14252e5b3e7a"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class BusyIndicator {
            static get Current() {
                if (!this.current) {
                    this.current = new BusyIndicator();
                }
                return this.current;
            }
            constructor() {
                this.timer = null;
                let me = this;
                me.$busyIndicatorAjax = $('#busy-indicator-ajax');
                me.$busyIndicatorNavigation = $('#busy-indicator-navigation');
                me.$busyIndicatorAjaxOverlay = $('#busy-indicator-ajax-overlay');
                CS.DOM.$win.on("beforeunload", function (e) {
                    me.Show();
                }).on('downloadfinished', function () {
                    me.Hide();
                });
                /*Ca fait blinker la page, donc, regarder qu'est-ce quon pourrait faire a place. Anyway,
                 le buzzy ajax apparait lui sauf lien externe*/
                //CS.DOM.$body.on('click', 'a', function (e) {
                //    if (e.isDefaultPrevented()) {
                //        return;
                //    }
                //    me.Show(false);
                //});
                CS.Ajax.AjaxListener.OnAjaxStateChange((state, extraParams, url) => {
                    if (state == CS.Ajax.AjaxState.Start) {
                        //me.Show(extraParams);
                        me.$busyIndicatorAjax.show();
                    }
                    else {
                        me.Hide();
                    }
                });
                requestAnimationFrame(function () {
                    me.Hide();
                });
            }
            Show(extraParameters = null) {
                if (CS.CommonData.Current.IsNativeApp && $('.popupwizard').length > 0) {
                    //Ne pas raffraichir si popupwizard est affiché en nativeapp
                    //doit retourner true pour que xamarin detecte que ca marche
                    return true;
                }
                let me = this;
                if (!extraParameters || extraParameters.isNavigation) {
                    me.$busyIndicatorNavigation.show();
                }
                else {
                    if (extraParameters.showTopBuzyIndicator) {
                        me.$busyIndicatorAjax.show();
                    }
                    if (extraParameters.makeUIReadOnly) {
                        me.$busyIndicatorAjaxOverlay.show();
                    }
                }
            }
            Hide() {
                this.$busyIndicatorAjax.hide();
                this.$busyIndicatorAjaxOverlay.hide();
                this.$busyIndicatorNavigation.hide();
            }
        }
        Controls.BusyIndicator = BusyIndicator;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=busy-indicator.js.map
